import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8d4fdca0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "system-info-wrapper" }
const _hoisted_2 = { class: "system-info-section" }
const _hoisted_3 = { class: "system-info-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "system-info-section" }
const _hoisted_6 = { class: "system-info-header" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "system-info-section" }
const _hoisted_10 = { class: "system-info-header" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "system-info-section"
}
const _hoisted_18 = { class: "system-info-header" }
const _hoisted_19 = { class: "anaplan-xl-actions" }
const _hoisted_20 = { class: "action-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_button = _resolveComponent("f-button")!
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.localizer.Localize("Header_Tenant")), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.Tenant.name), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.localizer.Localize("Header_Roles")), 1),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedRoles, (role) => {
          return (_openBlock(), _createElementBlock("div", null, _toDisplayString(role), 1))
        }), 256)),
        (_ctx.displayedRoles == null || _ctx.displayedRoles?.length == 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.localizer.Localize("No_Roles_Text")), 1))
          : _createCommentVNode("", true),
        (_ctx.UserData?.roles && _ctx.displayedRoles && _ctx.UserData?.roles?.length > _ctx.maxVisible)
          ? (_openBlock(), _createBlock(_component_f_button, {
              key: 1,
              class: "expand-btn",
              role: "button",
              text: "Button",
              type: "ghost",
              onClick: _ctx.toggleExpand
            }, {
              default: _withCtx(() => [
                _createVNode(_component_f_icon, {
                  icon: "chevrondown",
                  class: _normalizeClass({'is-expanded': _ctx.isExpanded }),
                  color: "primary"
                }, null, 8, ["class"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.isExpanded ? _ctx.localizer.Localize("Show_Less_Text") : `+${_ctx.UserData?.roles?.length - _ctx.displayedRoles?.length} ${_ctx.localizer.Localize("More_Text")}`), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.localizer.Localize("Header_Version")), 1),
      _createElementVNode("div", null, [
        _createElementVNode("div", null, _toDisplayString(_ctx.localizer.Localize("Header_Portal")) + ": 2605.1", 1),
        (_ctx.UserData?.releaseInfo != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.localizer.Localize("Header_Platform")) + ": " + _toDisplayString(_ctx.UserData?.releaseInfo?.platform), 1))
          : _createCommentVNode("", true),
        (_ctx.UserData?.releaseInfo != null && _ctx.UserData?.releaseInfo?.consolidationModule != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.localizer.Localize("Header_Consolidation")) + ": " + _toDisplayString(_ctx.UserData?.releaseInfo?.consolidationModule), 1))
          : _createCommentVNode("", true),
        (_ctx.UserData?.releaseInfo != null && _ctx.UserData?.releaseInfo?.accountRecModule != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.localizer.Localize("Header_Account_Rec")) + ": " + _toDisplayString(_ctx.UserData?.releaseInfo?.accountRecModule), 1))
          : _createCommentVNode("", true),
        (_ctx.UserData?.releaseInfo != null && _ctx.UserData?.releaseInfo?.matchingModule != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.localizer.Localize("Header_Transaction_Matching")) + ": " + _toDisplayString(_ctx.UserData?.releaseInfo.matchingModule), 1))
          : _createCommentVNode("", true),
        (_ctx.UserData?.releaseInfo != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.localizer.Localize("Header_AnaplanXL")) + ": " + _toDisplayString(_ctx.xl3Version ?? '...'), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.AXLDownloadLinkFeatureFlag)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_16))
      : _createCommentVNode("", true),
    (_ctx.AXLDownloadLinkFeatureFlag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.localizer.Localize("Header_Anaplan_XL_FCR")), 1),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_CommonButton, {
                type: _ctx.ButtonType.Default,
                text: _ctx.localizer.Localize('AnaplanXL_Download_EXE'),
                title: _ctx.localizer.Localize('AnaplanXL_Download_EXE_Title'),
                icon: "open",
                onClick: _ctx.handleDownloadEXE
              }, null, 8, ["type", "text", "title", "onClick"]),
              _createVNode(_component_CommonButton, {
                type: _ctx.ButtonType.Default,
                text: _ctx.localizer.Localize('AnaplanXL_Download_MSI'),
                title: _ctx.localizer.Localize('AnaplanXL_Download_MSI_Title'),
                icon: "open",
                onClick: _ctx.handleDownloadMSI
              }, null, 8, ["type", "text", "title", "onClick"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}